import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ops/legal/documents")({
  component: () => <Outlet />,
  head: () => ({ meta: [{ title: "Documentos Legales — Admin" }] }),
});
